import { render, staticRenderFns } from "./ApproveProject.vue?vue&type=template&id=4b5abd02&scoped=true"
import script from "./ApproveProject.vue?vue&type=script&lang=js"
export * from "./ApproveProject.vue?vue&type=script&lang=js"
import style0 from "./ApproveProject.vue?vue&type=style&index=0&id=4b5abd02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5abd02",
  null
  
)

export default component.exports